import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardRankingQuery, DataCardRankingSubscription } from '../types';

/**
 * typeguard for isValidDataCardRankingObject
 * @param obj object passed to transformer
 */
export const isValidDataCardRankingObject = (obj: DataCardRankingQuery) =>
  Boolean(obj?.data?.getCardCompetitionRanking) && !isEmptyObject(obj.data.getCardCompetitionRanking);

export const isValidDataCardRankingSubscriptionObject = (obj: DataCardRankingSubscription) =>
  Boolean(obj?.data?.onUpdateCardFootballRankingByCompetitionId) && !isEmptyObject(obj.data.onUpdateCardFootballRankingByCompetitionId);
